import { Fragment, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import navdots from '../../../Assets/images/navdots.svg';
import TrainingStatusModal from "../RequestorManagement/TrainingStatusModal";
import ConfirmationModal from "../../ConfirmationModal";
import { OverlayTrigger, Popover, Button } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";
import InviteSpecialDonorModal from "../../../Pages/Admin/SampleRequests/InviteSpecialDonorModal";
import TokenService from "../../../Services/Token.service";
function DonorTableRow({ donor, handleChangeStatus, fetchDonorList, sampleTypes, confirmSelectSpecificDonor }) {
    const navigate = useNavigate();
    const handleEditDonor = () => {

        navigate(`donor-profile/${donor.id}`);
    };

    const [showDeactivateModal, setShowDeactivateModal] = useState(false);

    const handleShowDeactivateModal = () => setShowDeactivateModal(true);
    const handleCloseDeactivateModal = () => setShowDeactivateModal(false);

    const confirmDeactivateUser = () => {
        handleChangeStatus(donor, donor.active);
        handleCloseDeactivateModal();
    };
    
    const [showSelectSpecificDonorModal, setShowSelectSpecificDonorModal] = useState(false);
    
    const handleShowSelectSpecificDonorModal = () => setShowSelectSpecificDonorModal(true);
    const handleCloseSelectSpecificDonorModal = () => setShowSelectSpecificDonorModal(false);


    
    const sampleIds = donor.sample_id ? donor.sample_id.split(',').map(id => id.trim()) : []; 

    const isMobile = useMediaQuery({ maxWidth: 768 });
    return ( 
        <>  
         {isMobile ? (
           <div className="admin-card-list">
          
             <div className="admin-card el-bg-table mb-2" >

               <div className="card-header">

               <div className="card-actions" style={{height:'10px'}}>
                <div className="el-board-table" style={{float:'right'}}>
                <div className="dropdown job-list-st-filter">
                        <Dropdown>
                            <Dropdown.Toggle variant="" className="btn btn-primary dropdown-toggle"   id="statusFilterDropdown">
                                <img src={navdots} alt="More actions" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="el-action">
                            {/* onClick={handleEditDonor}  */}
                                <Dropdown.Item as={Link} to={`donor-profile`} state={{ donor }}
                                onClick={() => {
                                    TokenService.updatePrevLink('/admin/donor-management');
                                }}>
                                    <label>View Details</label>
                                </Dropdown.Item>
                                <Dropdown.Item  onClick={()=>{handleShowSelectSpecificDonorModal()}}>
                                    <label>Invite</label>
                                </Dropdown.Item>
                                {/* onClick={() => handleChangeStatus(donor, donor.active)} */}
                                <Dropdown.Item onClick={handleShowDeactivateModal}>
                                    <label className={donor.active ? `text-danger` : `text-success`}>{donor.active ? 'Deactivate' : 'Activate'}</label>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
                 
               </div>


                 <h5></h5>
               
               </div>
                
               <div className=  {"card-body "} >
                 
               <p><strong>Donor Name: </strong> {donor.first_name} {donor.middle_name} {donor.last_name}</p>
                 <p>
                   <strong>Donor Status:</strong>{" "}
                   <span className={donor.active ? "badge bg-success" : "badge bg-danger"}>
                     {donor.active ? "Active" : "Inactive"}
                   </span>
                 </p>
                 <p><strong>XY or XX: </strong>   {donor.gender == 'XY' ? "Male (XY)" : "Female (XX)"}</p>

                 <p><strong>Sample Type:</strong>
                 <div className="el-flexarea-icon">
                    {sampleIds.length > 0 ? (
                        sampleIds.map((sampleId) => {
                            const sampleType = sampleTypes.find((type) => type.id === sampleId);
                            return sampleType ? (
                                // <OverlayTrigger
                                //     key={sampleId}
                                //     placement="right"
                                //     overlay={
                                //         <Popover id={`popover-${sampleId}`}>
                                //             <Popover.Header as="h3">{sampleType.label}</Popover.Header>
                                //         </Popover>
                                //     }
                                // >
                                //     <Button variant="outlined-secondary" className={sampleType.buttonClass}>
                                //         <i className={sampleType.className}></i>
                                //     </Button>

                                // </OverlayTrigger>
                                <Fragment key={sampleId}>
                                {sampleIds.length == 1 ? (<><div className={`btn bg-${sampleType.divClass} el-sample-btn `} key={sampleType.id}><i className={sampleType.className}></i> {sampleType.label}</div> </>) : (<><OverlayTrigger
                                    key={sampleId}
                                    placement="top"
                                    overlay={
                                        <Popover id={`popover-${sampleId}`}>
                                            <Popover.Header as="h3">{sampleType.label}</Popover.Header>
                                        </Popover>
                                    }
                                >
                                    {/* {sampleIds.length == 1 ? (<div className={`btn bg-${sampleType.divClass} el-sample-btn `} key={sampleType.id}><i className={sampleType.className}></i> {sampleType.label}</div>) :  ( */}
                                    <Button variant="outlined-secondary" className={sampleType.buttonClass}>
                                        <i className={sampleType.className}></i>
                                    </Button>
                                    {/* )}  */}
                                </OverlayTrigger>
                                </>)} 
                                </Fragment>
                            ) : null;
                        })
                    ) : (
                        "No samples available"
                    )}
                    </div>
                 </p>
                 <p><strong># of Donations:</strong> {donor.total_donations}</p>
               </div>
          
             </div>
           
         </div>
         ):(<>


            <tr>
                <td onClick={() => navigate('donor-profile', { state: { donor } })}
                style={{ cursor: 'pointer' }}>{donor.first_name} {donor.middle_name} {donor.last_name}</td>
                <td>
                    <div className={donor.active ? "el-active" : "el-inactive"}>
                        <div className={donor.active ? "el-activebtn" : "el-inactive"}></div>
                        {donor.active ? "Active" : "Inactive"}
                    </div>
                </td>
                <td>
                    {donor.gender == 'XY' ? "Male (XY)" : "Female (XX)"}
                </td>


                <td className="">
                {/* <div className="el-flexarea-icon"> */}
                <div className="el-icons-bg-box">
                    {sampleIds.length > 0 ? (
                        sampleIds.map((sampleId) => {
                            const sampleType = sampleTypes.find((type) => type.id === sampleId);
                            return sampleType ? (
                                // <OverlayTrigger
                                //     key={sampleId}
                                //     placement="right"
                                //     overlay={
                                //         <Popover id={`popover-${sampleId}`}>
                                //             <Popover.Header as="h3">{sampleType.label}</Popover.Header>
                                //         </Popover>
                                //     }
                                // >
                                //     <Button variant="outlined-secondary" className={sampleType.buttonClass}>
                                //         <i className={sampleType.className}></i>
                                //     </Button>

                                // </OverlayTrigger>
                                <Fragment key={sampleId}>
                                {sampleIds.length == 1 ? (<><div className={`btn bg-${sampleType.divClass} el-sample-btn `} key={sampleType.id}><i className={sampleType.className}></i> {sampleType.label}</div> </>) : (<><OverlayTrigger
                                    key={sampleId}
                                    placement="top"
                                    overlay={
                                        <Popover id={`popover-${sampleId}`}>
                                            <Popover.Header as="h3">{sampleType.label}</Popover.Header>
                                        </Popover>
                                    }
                                >
                                    {/* {sampleIds.length == 1 ? (<div className={`btn bg-${sampleType.divClass} el-sample-btn `} key={sampleType.id}><i className={sampleType.className}></i> {sampleType.label}</div>) :  ( */}
                                    <Button variant="outlined-secondary" className={sampleType.buttonClass}>
                                        <i className={sampleType.className}></i>
                                    </Button>
                                    {/* )}  */}
                                </OverlayTrigger>
                                </>)} 
                                </Fragment>
                            ) : null;
                        })
                    ) : (
                        "No samples available"
                    )}
                    </div>
                </td>
                <td>
                    {donor.total_donations}
                </td>
                <td>
                    <div className="dropdown">
                        <Dropdown>
                            <Dropdown.Toggle variant="" className="btn btn-primary dropdown-toggle" id="dropdown-basic">
                                <img src={navdots} alt="More actions" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="el-action">
                            {/* onClick={handleEditDonor}  */}
                                <Dropdown.Item as={Link} to={`donor-profile`} state={{ donor }}  
                                onClick={() => {
                                    TokenService.updatePrevLink('/admin/donor-management');
                                }}>
                                    <label>View Details</label>
                                </Dropdown.Item>
                                {donor.active && (
                                    <>
                                        <Dropdown.Item  onClick={()=>{handleShowSelectSpecificDonorModal()}}>
                                            <label>Invite</label>
                                        </Dropdown.Item> 
                                    </>
                                )}
                                {/* onClick={() => handleChangeStatus(donor, donor.active)} */}
                                <Dropdown.Item onClick={handleShowDeactivateModal}>
                                    <label className={donor.active ? `text-danger` : `text-success`}>{donor.active ? 'Deactivate' : 'Activate'}</label>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </td>
            </tr>
            </>
)}            
            <InviteSpecialDonorModal
                show={showSelectSpecificDonorModal}
                onHide={handleCloseSelectSpecificDonorModal}
                onConfirm={confirmSelectSpecificDonor} 
                id={donor.id}  //sending donor Id
                // ismatched ={sampleRequestDetails?.request?.matched_sample}
                type={"donor"}
            />
            <ConfirmationModal
                show={showDeactivateModal}
                onHide={handleCloseDeactivateModal}
                onConfirm={confirmDeactivateUser}
                title=""
                body={`Are you sure you want to ${donor.active ? 'deactivate' : 'activate'} user?`}
                type='deactivateactivate'
            />
        </>
    );
} 
export default DonorTableRow;